var _clipPath, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagEn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 5 3",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "t"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.5,1.5 h2.5 v1.5 z v1.5 h-2.5 z h-2.5 v-1.5 z v-1.5 h2.5 z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 v3 h5 v-3 z",
    fill: "#00247d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L5,3 M5,0 L0,3",
    stroke: "#fff",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L5,3 M5,0 L0,3",
    clipPath: "url(#t)",
    stroke: "#cf142b",
    strokeWidth: 0.33
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5,0 v3 M0,1.5 h5",
    stroke: "#fff",
    strokeWidth: 0.83
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5,0 v3 M0,1.5 h5",
    stroke: "#cf142b",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagEn);
export default __webpack_public_path__ + "static/media/flag-en.467b793af14cb86985c4487c83382d74.svg";
export { ForwardRef as ReactComponent };